export const RECOMMENDED_CLICK = 'Recommended click';
export const POPULAR_CLICK = 'Popular click';
export const RECENTLY_VISITED_CLICK = 'Recently visited click';
export const NEW_PRODUCT_CLICK = 'New product click';
export const COMING_SOON_CLICK = 'Coming soon click';
export const PRISMIC_PRODUCT_LIST_CLICK = 'Article product list click';
export const TRENDING_PRODUCT_CLICK = 'Trending product click';
export const OTHER_POPULAR_PRODUCT_CLICK = 'Popular product click';
export const OTHERS_ALSO_VISITED_PRODUCT_CLICK = 'Other visited product click';
